/* funzioni per cambiare i parametri della pagina valor_inmueble*/
$(document).on("keyup","#immobile-Prezzo",function(){
    updateButtonHref();
    changeSliderAnticipo($(this).val());
    $(this).val(formatNumber($(this).val()));
    
})
$(document).on("keyup","#mutuo-Anticipo",function(){
    updateButtonHref();
    $(this).val(formatNumber($(this).val()));
});
$(document).on("change","#mutuo-Durata",function(){
    updateButtonHref();
});

function updateButtonHref() {
    if ($('input#immobile-Prezzo').length) {
        mutuoImmobile = getNumber($("#immobile-Prezzo").val());
        //mutuoDurata = 30;
        hrefRichiestaMutuo = $("#richiesta-mutuo").attr("href").split("?")[0];
        $('#richiesta-mutuo').attr("href", hrefRichiestaMutuo +  "?importo_immobile="+mutuoImmobile);
    }
}

function changeSliderAnticipo($maxValue){
    $maxValue=getNumber($maxValue);
    var $minValue=Math.ceil($maxValue / 100 * 20);
    var $value = getNumber($("#mutuo-Anticipo").val());

    if($value< $minValue){
      $value=$minValue;
    } 
    else if($value > $maxValue){
      $value=$maxValue;
    } 

  $( "#slider-mutuo-anticipo" ).slider({
      range: "max",
      min: $minValue,
      max: $maxValue,
      value: $value,
      slide: function( event, ui ) {
        $( "#mutuo-Anticipo" ).val( formatNumber(ui.value) );
      }
    });
    $( "#mutuo-Anticipo" ).val( formatNumber($value));
}
$( document ).ready(function() {

  $( "#slider-immobile-prezzo" ).slider({
    range: "max",
    min: 1000,
    max: 200000,
    value: 100000,
    slide: function( event, ui ) {
      $( "#immobile-Prezzo" ).val( formatNumber(ui.value ));
      changeSliderAnticipo(ui.value);
      updateButtonHref();
    }
  });

  $( "#slider-mutuo-anticipo" ).slider({
    range: "max",
    min: 200,
    max: 100000,
    value: 20000,
    slide: function( event, ui ) {
      $( "#mutuo-Anticipo" ).val( formatNumber(ui.value ));
      updateButtonHref();
    }
  });
});